export default __webpack_public_path__ + "locales/si/ChangeUserTypeDialog.json?hash=8b20929fdd48e4df1d6743671338942f";